export default __webpack_public_path__ + "static/media/120.764c20b5.jpeg";